import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'
import React from 'react'
import ReactDOM from 'react-dom'
import ReactGA from 'react-ga'
import 'normalize.css'

import './styles/index.css'
// import './fonts/effra.css'
// import './fonts/basis-grotesque.css'
import './fonts/PlutoSans/plutosans.css'

import './setupTalGel'
import { GelThemeProvider } from '@tal-gel/theming'
import { GelScreenDetector } from '@tal-gel/components'

import App from './App'

ReactGA.initialize('UA-123824849-4')

const rootEl = document.getElementById('root')
ReactDOM.render(
  <GelThemeProvider mode={process.env.NODE_ENV}>
    <GelScreenDetector>
      <App />
    </GelScreenDetector>
  </GelThemeProvider>,
  rootEl
)

// hot reload
if (module.hot) {
  module.hot.accept('./App', () => {
    const NextApp = require('./App').default
    ReactDOM.render(
      <GelThemeProvider mode={process.env.NODE_ENV}>
        <GelScreenDetector>
          <NextApp />
        </GelScreenDetector>
      </GelThemeProvider>,
      rootEl
    )
  })
}
